import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import './style.scss'
import { ReactComponent as SearchIcon } from '../../assets/svg/icon-search.svg'

const SearchForm = props => {
  const [value, setValue] = useState('')
  const navigate = useNavigate()

  const handleSubmit = e => {
    e.preventDefault()

    const query = value.trim().toLowerCase()

    if (!query) return navigate(`/`)

    navigate(`/search/${query}`)
  }

  return (
    <div className="search-form-wrapper">
      <form className="search-form" onSubmit={e => handleSubmit(e)}>
        <div className="input-wrapper">
          <input
            type="text"
            name="search"
            id="search"
            placeholder="find something"
            autoComplete="off"
            spellCheck="false"
            value={value}
            onChange={e => setValue(e.target.value)}
          />
          <label htmlFor="search">find something</label>
        </div>
        <button type="submit" aria-label="Submit" title="Submit">
          <SearchIcon/>
        </button>
      </form>
      <div className="search-categories">
        <Link to="/search/music" className="category-suggestion">
          <SearchIcon/>
          <span>
            music
          </span>
        </Link>
        <Link to="/search/cat" className="category-suggestion">
          <SearchIcon/>
          <span>
            cat
          </span>
        </Link>
        <Link to="/search/monkey" className="category-suggestion">
          <SearchIcon/>
          <span>
            monkey
          </span>
        </Link>
        <Link to="/search/trailer" className="category-suggestion">
          <SearchIcon/>
          <span>
            trailer
          </span>
        </Link>
      </div>
    </div>
  )
}

export default SearchForm